<template>
  <div class="pay-content">
    <advertising-figure :bannerSrc="bannerSrc" />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="pay-dialong">
      <div class="title">微信支付</div>
      <div class="pay-info">
        <div class="info-left">
          <!-- <img
            src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.xjishu.com%2Fimg%2Fzl%2F2017%2F10%2F19454498268039.gif&refer=http%3A%2F%2Fimg.xjishu.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1653038290&t=41816c683a66550b1dbbb7b5229e0e6b"
            alt=""
          /> -->
          <h5 class="tips" v-if="loadingQrCode">加载支付二维码中...</h5>
          <VueQr
            class="qr-code"
            v-else
            :text="payQrUrl"
            :size="400"
            :margin="0"
            :correct-level="3"
            :logo-src="require('@/assets/logo.png')"
          ></VueQr>
          <div class="btn-group">
            <button>请使用微信扫一扫,扫描二维码支付</button>
            <button @click.stop="handleFinishPay(false)">
              手机微信支付完成后点击此按钮
            </button>
          </div>
        </div>
        <div class="info-right">
          <img src="@/assets/img/wechatpay-qrcode.png" alt="" />
        </div>
      </div>
    </div>
    <public-dialog v-model="dialogShow">
      <div class="dialog-info-wrap">
        <h2 class="dialog-tit">重要提醒</h2>
        <div class="info">
          <p>
            报名后因特殊原因无法参会的，请于{{
              beforeconfdate
            }}24点会议开始前申请退款，{{ confdate }}0点起将无法退款
          </p>
        </div>
        <el-button right type="primary" @click="dialogShow = false"
          >关闭</el-button
        >
      </div>
    </public-dialog>
  </div>
</template>

<script>
  import VueQr from "vue-qr"
  import dayjs from "dayjs"
  import "dayjs/locale/zh-cn"
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import { UserOrderRecord } from "@/store/entity/pay"
  import PublicDialog from "@/components/dialog"
  import CurrentUserMixin from "@/mixin/CurrentUser"

  export default {
    name: "wechatpayDesktop",
    components: {
      AdvertisingFigure,
      InnerPageNav,
      VueQr,
      PublicDialog,
    },
    mixins: [CurrentUserMixin],
    data() {
      return {
        bannerSrc: require("@assets/img/registration-banner.png"),
        payQrUrl: null,
        loadingQrCode: true,
        trade_no: null,
        dialogShow: false,
      }
    },

    computed: {
      beforeconfdate() {
        const confdate = this.currentSignup.conference.conferencedate
        return dayjs(confdate).subtract(1, "day").format("YYYY年MM月DD日")
      },
      confdate() {
        const confdate = this.currentSignup.conference.conferencedate
        return dayjs(confdate).format("YYYY年MM月DD日")
      },
    },

    mounted() {
      this.createWechatOrder()

      // 轮询查询是否支付状态
      this.interval = window.setInterval(() => {
        setTimeout(this.handleFinishPay(true), 0)
      }, 5000)
    },

    beforeDestroy() {
      //清除轮询
      clearInterval(this.interval)
      this.interval = null
    },
    methods: {
      async createWechatOrder() {
        const signupId = this.$route.query.signupId
        const orderInfo = await UserOrderRecord.createOrder({
          signup_id: signupId,
          trade_type: "NATIVE",
        })
        this.payQrUrl = orderInfo.wechatpay_info.code_url
        this.trade_no = orderInfo.trade_no
        this.loadingQrCode = false
      },

      async handleFinishPay(omitError) {
        // 给后台发请求调查单接口是否已支付完成
        if (!this.trade_no) {
          return
        }
        try {
          await UserOrderRecord.finisheOrder({ trade_no: this.trade_no })
          // 因为getSignupInfo是有缓存的，先重置状态再获取
          await this.$store.dispatch("user/resetFetchSignupInfo")
          this.$message("支付成功，将跳转到报名信息页面")
          setTimeout(
            () => this.$router.replace({ name: "RegistrationDetail" }),
            500
          )
        } catch (error) {
          const msg = error.response.data.msg
          if (!omitError) {
            this.$message("支付失败：" + msg)
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";
  .pay-content {
    width: 100%;
  }
  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .pay-dialong {
    width: 1200px;
    margin: 50px auto;
    box-sizing: border-box;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);

    .title {
      padding: 0 15px;
      color: #fff;
      height: 44px;
      line-height: 44px;
      background: #fe0000;
    }

    .pay-info {
      display: flex;
      align-items: center;
      margin: 50px 0;

      .info-left {
        flex: auto;
        text-align: center;
        padding: 0 20px 0 50px;

        .qr-code {
          width: 252px;
          padding: 3px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }

        .btn-group {
          width: 252px;
          margin: 0 auto;
          button {
            display: block;
            width: 100%;
            height: 35px;
            font-size: 14px;
            line-height: 35px;
            border-radius: 35px;
            border: none;
            outline: none;
            margin-top: 25px;

            &:first-child {
              background: #999;
              color: #fff;
            }

            &:last-child {
              background: #fe0000;
              color: #fff;
            }
          }
        }
      }

      .info-right {
        flex: auto;
        padding: 0 50px 0 20px;
        text-align: center;

        img {
          width: 450px;
        }
      }
    }
  }
  .dialog-info-wrap {
    width: 100%;

    .dialog-tit {
      font-size: 16px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }
    .info {
      margin-top: 15px;
      margin-bottom: 15px;

      p {
        line-height: 60px;
      }
    }
  }
</style>
